import React from 'react';
import { connect } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import HomePage from 'containers/Home/index';
import IntermodalDispatch from 'containers/Dispatch/model/intermodal';
import OtrDispatch from 'containers/Dispatch/model/longhaul';
import PaymentCompletePage from 'containers/stripe/payment-complete';
import BrokerPage from 'containers/Broker/broker-page';
import LocationPage from 'containers/Location/location-page';
import DriverPage from 'containers/Driver/driver-page';
import EquipmentPage from 'containers/Equipment/equipment-page';
import InvoiceManager from 'containers/Accounting/invoice-manager';
import BillManager from 'containers/Accounting/bill-manager';
import TenantPage from 'containers/tenant/tenant-page';
import ReportPage from 'containers/Report/report-page';

import {fetchBrokers} from 'actions/broker-action';
import {fetchLocations} from 'actions/location-action';
import {fetchDrivers} from 'actions/driver-action';
import {fetchEquipments} from 'actions/equipment-action';
import { getTenant, listUsers, getSchedule } from 'actions/tenant-action';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { fetchTrucks } from 'actions/truck-action';
import { FSConfig } from 'freightsmart-config';

const renderComponentPage = (component, location) => {
  switch (component) {
  case 'home':
    return <HomePage />;
  case 'intermodal':
    return <IntermodalDispatch location={location}/>;
  case 'longhaul':
    return < OtrDispatch location={location}/>;    
  case 'brokers':
    return <BrokerPage />;
  case 'locations':
    return <LocationPage />;
  case 'drivers':
    return <DriverPage />;
  case 'equipments':
    return <EquipmentPage />;
  case 'accounting':
    return <InvoiceManager />;
  case 'payments':
    return <BillManager />;
  case 'profile':
    return <TenantPage />;
  case 'dashboard':
    return <ReportPage />;
  case 'complete':
    const stripePromise = loadStripe(FSConfig.stripePublicationKey);
    return <Elements stripe={stripePromise}>
        <PaymentCompletePage />
      </Elements> 
  default:
    return null;
  }
};

const DataContainer = (props) => {
  const { brokerReducer, locationReducer, driverReducer, equipmentReducer, truckReducer, tenantReducer, schedulerReducer } = props;
  if (!brokerReducer.isProcessing && !brokerReducer.isLoaded) {
    props.fetchBrokers();
  }
  if (!locationReducer.isProcessing && !locationReducer.isLoaded) {
    props.fetchLocations();
  }

  if (!driverReducer.isProcessing && !driverReducer.isLoaded) {
    props.fetchDrivers();
  }

  if (!equipmentReducer.isProcessing && !equipmentReducer.isLoaded) {
    props.fetchEquipments();
  }

  if (!truckReducer.isLoading && !truckReducer.isLoaded) {
    props.fetchTrucks();
  }

  if (!tenantReducer.isProcessing && !tenantReducer.isLoaded) {
    const tenantId = localStorage.getItem('CT_TENANTID');
    props.getTenant(tenantId);
    props.listUsers(tenantId);
  }

  // if(!schedulerReducer.isProcessing && !schedulerReducer.isLoaded) {
  //   props.getSchedule();
  // }

  const { component } = useParams();
  const location = useLocation();

  return (    
    renderComponentPage(component, location)
  );
};

const mapStatesToProps = state => ({
  brokerReducer: state.brokerReducer,
  locationReducer: state.locationReducer,
  driverReducer: state.driverReducer,
  equipmentReducer: state.equipmentReducer,
  truckReducer: state.truckReducer,
  tenantReducer: state.tenantReducer,
  schedulerReducer: state.schedulerReducer
});

function mapDispatchToProps(dispatch) {
  return {
    fetchBrokers: () => dispatch(fetchBrokers()),
    fetchLocations: () => dispatch(fetchLocations()),
    fetchDrivers: () => dispatch(fetchDrivers()),
    fetchEquipments: () => dispatch(fetchEquipments()),
    fetchTrucks: () => dispatch(fetchTrucks()),
    getTenant: (tenantId) => dispatch(getTenant(tenantId)),
    listUsers: (tenantId) => dispatch(listUsers(tenantId)),    
    getSchedule: () => dispatch(getSchedule()),
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(DataContainer);
